import { supabase } from '../lib/supabase';

export const reportService = {
  // Create a new report
  async createReport({ subjectType, subjectId, reason, description }) {
    try {
      const { data, error } = await supabase
        .from('reports')
        .insert({
          subject_type: subjectType,
          subject_id: subjectId,
          reporter_id: (await supabase.auth.getUser()).data.user.id,
          reason,
          description,
          status: 'pending'
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Create report error:', error);
      throw error;
    }
  },

  // Get reports for admin
  async getReports(status = null, limit = 20, offset = 0) {
    try {
      let query = supabase
        .from('reports')
        .select(`
          *,
          reporter:profiles!reporter_id (
            display_name,
            email
          )
        `)
        .range(offset, offset + limit - 1)
        .order('created_at', { ascending: false });

      if (status) {
        query = query.eq('status', status);
      }

      const { data, error, count } = await query;

      if (error) throw error;
      return { reports: data, count };
    } catch (error) {
      console.error('Get reports error:', error);
      throw error;
    }
  },

  // Update report status (admin only)
  async updateReportStatus(reportId, status, resolvedBy) {
    try {
      const { data, error } = await supabase
        .from('reports')
        .update({
          status,
          resolved_at: new Date().toISOString(),
          resolved_by: resolvedBy
        })
        .eq('id', reportId)
        .select()
        .single();

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Update report status error:', error);
      throw error;
    }
  },

  // Get report stats (admin only)
  async getReportStats() {
    try {
      const { data: pending, error: pendingError } = await supabase
        .from('reports')
        .select('id', { count: 'exact' })
        .eq('status', 'pending');

      const { data: total, error: totalError } = await supabase
        .from('reports')
        .select('id', { count: 'exact' });

      if (pendingError || totalError) throw pendingError || totalError;

      return {
        pending: pending?.length || 0,
        total: total?.length || 0
      };
    } catch (error) {
      console.error('Get report stats error:', error);
      throw error;
    }
  }
};